export const stylists = [
  {
    name: 'Jonathan Johnson',
    rating: '5',
    image: 'https://images.pexels.com/photos/2380794/pexels-photo-2380794.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260'
  },
  {
    name: 'Omelete Du Fromage',
    rating: '3.5',
    image: 'https://images.pexels.com/photos/2099225/pexels-photo-2099225.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260'
  },
  {
    name: 'Suzy Q',
    rating: '4.5',
    image: 'https://images.pexels.com/photos/2690323/pexels-photo-2690323.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260'
  },
  {
    name: 'Ali bin Abu',
    rating: '4.5',
    image: 'https://images.pexels.com/photos/1270076/pexels-photo-1270076.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260'
  },
  {
    name: 'Olly bin Oboe',
    rating: '4.5',
    image: 'https://images.pexels.com/photos/1270076/pexels-photo-1270076.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260'
  },
  {
    name: 'Ez',
    rating: '4.5',
    image: 'https://images.pexels.com/photos/1270076/pexels-photo-1270076.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260'
  },
  {
    name: 'Bez',
    rating: '4.5',
    image: 'https://images.pexels.com/photos/1270076/pexels-photo-1270076.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260'
  },
  {
    name: 'Rez',
    rating: '4.5',
    image: 'https://images.pexels.com/photos/1270076/pexels-photo-1270076.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260'
  },
  {
    name: 'Fez',
    rating: '4.5',
    image: 'https://images.pexels.com/photos/1270076/pexels-photo-1270076.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260'
  }
]

export const salonBusinessHours = [
  { day: 'Mon', hours: '11am - 8.30pm' },
  { day: 'Tue', hours: '11am - 8pm' },
  { day: 'Wed', hours: '12am - 8.30pm' },
  { day: 'Thu', hours: '11am - 8pm' },
  { day: 'Fri', hours: '11am - 8pm' },
  { day: 'Sat', hours: '10am - 8pm' },
  { day: 'Sun', hours: '10am - 8pm' }
]
